import { AbstractControl, ValidationErrors } from '@angular/forms';

export const CheckedValidator = (
  control: AbstractControl<boolean>
): ValidationErrors | null => {
  if (!control.value) {
    return { requiredCheck: true };
  } else {
    return null;
  }
};
